/**
 * Active module state — which inspection discipline the user is working in.
 * Persisted in localStorage; Pool & Spa is the default/master module.
 */
export const MODULES = {
  pool_spa: { key: "pool_spa", name: "Pool & Spa", type: "private", tracker: false },
  health: { key: "health", name: "Health", type: "council", tracker: true },
  building: { key: "building", name: "Building Compliance", type: "council", tracker: true },
  pest: { key: "pest", name: "Pest & Building", type: "private", tracker: true },
  certification: { key: "certification", name: "Certification", type: "private", tracker: true },
  fire: { key: "fire", name: "Fire Safety", type: "council", tracker: true },
};

const KEY = "ch_active_module";

export const getActiveModule = () => {
  const m = localStorage.getItem(KEY);
  return MODULES[m] ? m : "pool_spa";
};

export const setActiveModule = (slug) => {
  if (MODULES[slug]) {
    localStorage.setItem(KEY, slug);
    window.dispatchEvent(new Event("ch:module-changed"));
  }
};

export const activeModuleMeta = () => MODULES[getActiveModule()];
export const usesTracker = () => activeModuleMeta().tracker;
